import {useProjectStore} from '@/store/projectStore';
import type {ProjectId} from '@/types';

export function getCurrentProjectId(): ProjectId | undefined {
    if (typeof window !== 'undefined') {
        const urlProjectId = new URLSearchParams(window.location.search).get('projectId');
        if (urlProjectId) {
            return urlProjectId;
        }
    }

    return useProjectStore.getState().currentProjectId || undefined;
}
